export default __webpack_public_path__ + "static/media/Newspaper.ac7ab71e.svg";